import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

export default {
  state: () => ({
    selectedAdditionalServiceParkourBasedPricings: { scheduleIds: [], name: null, startDate: null, endDate: null, parkourBasedPricingFragments: [] },
  }),

  mutations: {
    setSelectedAdditionalServiceParkourBasedPricings(state, additionalServiceParkourBasedPricings) {
      Vue.set(state, "selectedParkourBasedPricings", additionalServiceParkourBasedPricings);
    },
  },

  actions: {
    //TODO: load, update, create
    createAdditionalServiceParkourBasedPricings: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/additional-service-parkour-based-pricings/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadAdditionalServiceParkourBasedPricings: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/additional-service-parkour-based-pricings/entity").then((response) => {
        return objectUtils.convertPublishModelToUpdateModel(response.data);
      });
    },

    loadAdditionalServiceParkourBasedPricing: (context, id) => {
      return axios.get(context.getters.getMcServiceUrl + "/additional-service-parkour-based-pricings/entity/" + id).then((response) => {
        // return objectUtils.convertPublishModelToUpdateModel(response.data);
        return response.data;
      });
    },

    loadPublishedAdditionalServiceParkourBasedPricings: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/additional-service-parkour-based-pricings/entity/published").then((response) => {
        return response.data;
      });
    },

    updateAdditionalServiceParkourBasedPricings: (context, request) => {
      return axios.put(context.getters.getMcServiceUrl + "/additional-service-parkour-based-pricings/entity", request, {}).then((response) => {
        return response.data;
      });
    },
    deleteAdditionalServiceParkourBasedPricings: (context, additionalServiceParkourBasedPricings) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/additional-service-parkour-based-pricings/entity/" + additionalServiceParkourBasedPricings.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          additionalServiceParkourBasedPricings.intents = intents;
          additionalServiceParkourBasedPricings.intentId = response.data.id;
          return additionalServiceParkourBasedPricings;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftAdditionalServiceParkourBasedPricings: (context, additionalServiceParkourBasedPricings) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/additional-service-parkour-based-pricings/draft/" + additionalServiceParkourBasedPricings.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishAdditionalServiceParkourBasedPricings: (context, intentId) => {
      return axios.get(context.getters.getMcServiceUrl + "/additional-service-parkour-based-pricings/publish/" + intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },

    loadSelectedAdditionalServiceParkourBasedPricingsHistory: (context, additionalServiceParkourBasedPricings) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/additional-service-parkour-based-pricings/history/" + additionalServiceParkourBasedPricings.id, {})
        .then((response) => {
          return response.data;
        });
    },

    rejectAdditionalServiceParkourBasedPricings: (context, additionalServiceParkourBasedPricings) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/additional-service-parkour-based-pricings/reject/" + additionalServiceParkourBasedPricings.intentId)
        .then((response) => {
          if (additionalServiceParkourBasedPricings.intents[0].type === "DELETE_ADDITIONAL_SERVICE_PARKOUR_BASED_PRICING") {
            additionalServiceParkourBasedPricings.intents = null;
            additionalServiceParkourBasedPricings.intentId = 0;
          } else if (additionalServiceParkourBasedPricings.intents[0].type === "CREATE_ADDITIONAL_SERVICE_PARKOUR_BASED_PRICING") {
            additionalServiceParkourBasedPricings.intents[0].status = "DRAFT";
          } else if (additionalServiceParkourBasedPricings.intents[0].type === "UPDATE_ADDITIONAL_SERVICE_PARKOUR_BASED_PRICING") {
            additionalServiceParkourBasedPricings.intents[0].status = "DRAFT";
          }
          return response.data;
        });
    },

    recallAdditionalServiceParkourBasedPricings: (context, additionalServiceParkourBasedPricings) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/additional-service-parkour-based-pricings/recall/" + additionalServiceParkourBasedPricings.intentId)
        .then((response) => {
          //TODO:Name should starting with letter.
          helper.recallOrRejectEntity(additionalServiceParkourBasedPricings, "PARKOUR_BASED_PRICING");
          return response.data;
        });
    },

    cancelAdditionalServiceParkourBasedPricings: (context, additionalServiceParkourBasedPricings) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/additional-service-parkour-based-pricings/cancel/" + additionalServiceParkourBasedPricings.intentId)
        .then((response) => {
          //TODO:Name should starting with letter.
          return response.data;
        });
    },

    sendToApprovalAdditionalServiceParkourBasedPricings: (context, additionalServiceParkourBasedPricings) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/additional-service-parkour-based-pricings/sendToApproval/" + additionalServiceParkourBasedPricings.intentId)
        .then((response) => {
          if (additionalServiceParkourBasedPricings.intents[0].type === "CREATE_ADDITIONAL_SERVICE_PARKOUR_BASED_PRICING") {
            additionalServiceParkourBasedPricings.intents[0].status = "WAITING_APPROVAL";
          } else if (additionalServiceParkourBasedPricings.intents[0].type === "'CREATE_ADDITIONAL_SERVICE_PARKOUR_BASED_PRICING") {
            additionalServiceParkourBasedPricings.intents[0].status = "WAITING_APPROVAL";
          }
          return response.data;
        });
    },
  },
  getters: {
    getSelectedAdditionalServiceParkourBasedPricings: (state) => {
      return state.selectedAdditionalServiceParkourBasedPricings;
    },
  },
};
